import { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faPython, faCss3, faGitAlt, faHtml5, faJsSquare, faReact, faSass, faBootstrap, faGithub} from '@fortawesome/free-brands-svg-icons'
import { SiNextdotjs, SiRedux, SiAdobephotoshop, SiTypescript, SiTailwindcss, SiDjango, SiPostgresql, SiFlask } from 'react-icons/si';
import AnimatedLetters from '../AnimatedLetters'
import Loader from 'react-loaders'
import './index.scss'




const About = () => {

    const [letterClass, setLetterClass] = useState('text-animate')
    

    useEffect(() => {
        setTimeout(() => {
          return setLetterClass('text-animate-hover')
        }, 3000)
      }, [])

      return (
        <>
          <div className="container about-page">
            <div className="text-zone">
              <h1>
                <AnimatedLetters
                  letterClass={letterClass}
                  strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
                  idx={15}
                />
              </h1>
              <p>
              I'm a highly ambitious fullstack developer seeking an opportunity to grow and provide value through my skills.
              I have a strong skill set in JavaScript, React, Python, and Flask, and a proficiency in fullstack development. 
              I'm particularly interested in working on diverse and challenging projects that allow me to utilize the latest technologies.
              </p>
              <p align="LEFT">
                I'm quiet confident, naturally curious, and perpetually working on
                improving my chops one development problem at a time.
              </p>
              <p>
                If I were to define myself in one sentence, I would describe myself as an adventurer, photography enthusiast, weightlifter, and tech-obsessed!!
              </p>
              <h2 id='small-head' style={{fontWeight:'bold', color: 'black'}}>My Skills:</h2>
              <div className='slider'>

                <div className='slide-track'>

                  <div className='slide'>
                    <SiRedux className='icons' color="#764BBC"/>
                  </div>
                  <div className='slide'>
                    <SiNextdotjs className='icons' color='black'/>
                  </div>
                  <div className='slide'>
                    <SiPostgresql className='icons' color="#31C5F0"/>
                  </div>
                  <div className='slide'>
                    <SiDjango className='icons' color="#2AA474"/>
                  </div>
                  <div className='slide'>
                    <SiFlask className='icons' color="black"/>
                  </div>
                  <div className='slide'>
                    <SiTailwindcss className='icons' color="#37B7F1"/>
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faGithub} color='black' />
                  </div>
                  <div className='slide'>
                    <SiTypescript className='icons' color="#2E75C0"/>
                  </div>
                  <div className='slide'>
                    <SiAdobephotoshop className='icons' color="#31C5F0"/>
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faBootstrap} color="#8813F7" />
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faSass} color="#C76396" />
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faPython} color="#DD0031" />
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faHtml5} color="#F06529" />
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faCss3} color="#28A4D9" />
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faReact} color="#5ED4F4" />
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faJsSquare} color="#EFD81D" />
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faGitAlt} color="#EC4D28" />
                  </div>

                  <div className='slide'>
                    <SiRedux className='icons' color="#764BBC"/>
                  </div>
                  <div className='slide'>
                    <SiNextdotjs className='icons' color='black'/>
                  </div>
                  <div className='slide'>
                    <SiPostgresql className='icons' color="#31C5F0"/>
                  </div>
                  <div className='slide'>
                    <SiDjango className='icons' color="#2AA474"/>
                  </div>
                  <div className='slide'>
                    <SiFlask className='icons' color="black"/>
                  </div>
                  <div className='slide'>
                    <SiTailwindcss className='icons' color="#37B7F1"/>
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faGithub} color='black' />
                  </div>
                  <div className='slide'>
                    <SiTypescript className='icons' color="#2E75C0"/>
                  </div>
                  <div className='slide'>
                    <SiAdobephotoshop className='icons' color="#31C5F0"/>
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faBootstrap} color="#8813F7" />
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faSass} color="#C76396" />
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faPython} color="#DD0031" />
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faHtml5} color="#F06529" />
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faCss3} color="#28A4D9" />
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faReact} color="#5ED4F4" />
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faJsSquare} color="#EFD81D" />
                  </div>
                  <div className='slide'>
                    <FontAwesomeIcon className='icons' icon={faGitAlt} color="#EC4D28" />
                  </div>

                </div>

              </div>
            </div>
    
            <div className="stage-cube-cont">
              <div className="cubespinner">
                <div className="face1">
                  <FontAwesomeIcon icon={faPython} color="#DD0031" />
                </div>
                <div className="face2">
                  <FontAwesomeIcon icon={faHtml5} color="#F06529" />
                </div>
                <div className="face3">
                  <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
                </div>
                <div className="face4">
                  <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
                </div>
                <div className="face5">
                  <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
                </div>
                <div className="face6">
                  <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />
                </div>
              </div>
            </div>
          </div>
          <Loader type="pacman" />
        </>
      )
    }

export default About